import { useCallback, useMemo } from "react";
import {
  RENDER_MODE_LABELS,
  renderScopeFor,
  VIEW_MODES_BY_SCOPE,
} from "../app/renderConfig.ts";
import { useStore } from "../app/store.ts";
import type { ViewMode } from "../app/storeTypes.ts";
import { useOperatorMenu } from "./hooks/useOperatorMenu.ts";
import { PieMenu, type PieMenuOption } from "./PieMenu.tsx";

export function RenderMethodPieMenu() {
  const menu = useOperatorMenu("renderMethodPie");
  const workspaceMode = useStore((s) => s.workspaceMode);
  const renderConfigs = useStore((s) => s.renderConfigs);
  const setRenderSetting = useStore((s) => s.setRenderSetting);

  const scope = renderScopeFor(workspaceMode);
  const activeViewMode = renderConfigs[scope].viewMode;

  const options = useMemo<PieMenuOption[]>(
    () =>
      VIEW_MODES_BY_SCOPE[scope].map((mode) => ({
        id: mode,
        label: RENDER_MODE_LABELS[mode],
        disabled: mode === activeViewMode,
      })),
    [activeViewMode, scope],
  );

  const handleSelect = useCallback(
    (id: string) => {
      setRenderSetting(scope, "viewMode", id as ViewMode);
      menu.close();
    },
    [menu, scope, setRenderSetting],
  );

  if (options.length === 0) return null;

  return (
    <PieMenu
      open={menu.open}
      onClose={menu.close}
      onSelect={handleSelect}
      anchorPoint={menu.anchorPoint}
      options={options}
      holdKey="z"
    />
  );
}
